export default __webpack_public_path__ + "static/media/Iltfat-Aliyev.b84eda22.png";